class LoginStatusTypeObject {
  constructor(code) {
    this.code = code;
    this.data = {};
  }

  SetData(data) {
    this.data = data;
  }
}

const LoginStatusType = {
  Failed: new LoginStatusTypeObject(0),
  Success: new LoginStatusTypeObject(1),
  Cancel: new LoginStatusTypeObject(2),
  AlreadyLogin: new LoginStatusTypeObject(3),
  AccountLocked: new LoginStatusTypeObject(4),
  PasswordExpired: new LoginStatusTypeObject(5)
};
export default LoginStatusType;
